import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import ExecAsks from './ExecAsks';

// Asks for the people an Executive has shared them with (Administration → Asks).
// Same screen the Executive page uses; the server only ever hands a shared sender
// the asks they sent themselves.
export default function AdminAsks() {
  const [sp] = useSearchParams();
  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Asks</h1>
          <p className="admin-page-sub">Send an RSVP, a question, a pick-one or a note to acknowledge — and watch the answers come in.</p>
        </div>
      </div>
      <ExecAsks openId={sp.get('ask')} />
    </AdminLayout>
  );
}
